import { render } from "./Agreement8.vue?vue&type=template&id=738b42de"
import script from "./Agreement8.vue?vue&type=script&lang=js"
export * from "./Agreement8.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__